var map = {
	"./app-google-da-DK.svg": 79878,
	"./app-google-de-DE.svg": 95127,
	"./app-google-en-GB.svg": 2450,
	"./app-google-en-US.svg": 86053,
	"./app-google-es-ES.svg": 2834,
	"./app-google-es-MX.svg": 99148,
	"./app-google-fr-FR.svg": 5225,
	"./app-google-it-IT.svg": 47704,
	"./app-google-nb-NO.svg": 62364,
	"./app-google-nl-NL.svg": 32920,
	"./app-google-pl-PL.svg": 58589,
	"./app-google-pt-BR.svg": 47991,
	"./app-google-pt-PT.svg": 39035,
	"./app-google-sv-SE.svg": 20173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48648;